import React, {useEffect, useMemo, useRef, useState} from 'react';
import useYousignDocuments from "../../hooks/useYousignDocuments";
import {Col, DatePicker, Row, Select, Space, Spin, Table, Typography} from "antd";
import {youSignColumns} from "./columns";

import locale from 'antd/es/date-picker/locale/fr_FR';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

const {Title, Text} = Typography;

const Yousign = () => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [pickerValue, setPickerValue] = useState(dayjs());
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [tableHeight, setTableHeight] = useState(600);

  const {documents,years,loading} = useYousignDocuments(selectedYear);

  const containerRef = useRef();

  useEffect(() => {
    setPickerValue(dayjs().year(selectedYear).startOf('year'));
    // Réinitialisation des dates sélectionnées
    setStartDate(null);
    setEndDate(null);

  }, [selectedYear]);

  const handleYearChange = (value) => {
    setSelectedYear(parseInt(value));
  };

  const updateTableHeight = () => {
    if (containerRef.current) {
      const windowHeight = window.innerHeight;
      const containerTop = containerRef.current.getBoundingClientRect().top;
      const footerHeight = 90; // Hauteur estimée pour le pied de page ou autres éléments

      // Calculer la hauteur disponible
      const availableHeight = windowHeight - containerTop - footerHeight;
      setTableHeight(availableHeight > 200 ? availableHeight : 200); // Minimum de 200px
    }
  };

  const filteredDocuments = useMemo(() => {
    if (!documents) return [];

    return documents.filter(doc => {
      if (!doc.created_date) return true; // Ou false selon si vous voulez garder les docs sans date

      const docDate = dayjs(doc.created_date);

      // Vérification de la borne de début
      if (startDate && docDate.isBefore(startDate, 'day')) {
        return false;
      }

      // Vérification de la borne de fin
      if (endDate && docDate.isAfter(endDate, 'day')) {
        return false;
      }

      return true;
    });
  }, [documents, startDate, endDate]);

// Calculez le nouveau compte pour l'affichage
  const filteredCount = filteredDocuments.length;

  useEffect(() => {
    // Mettre à jour la hauteur au chargement
    updateTableHeight();
    // Ajouter un écouteur d'événement pour le redimensionnement de la fenêtre
    window.addEventListener('resize', updateTableHeight);
    // Nettoyer l'écouteur lors du démontage du composant
    return () => window.removeEventListener('resize', updateTableHeight);
  }, []);

  const handleRefresh = (record) => {
    const urlRefresh = `https://api.yousign.app/v3/signature_requests/${record?.document}`;
    fetch(urlRefresh, {
      method: "GET",
      headers: {
        Authorization: "Bearer 8lj0pevKaOYCEpceDU3P4hBMhw2kl9fA",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        // mise à jour document
        // juste le status
        /*props.updateDocument(
          {
            document_nom: document.document_nom,
            document_dispo_mail: false,
            document_yousign_document_id: document.document_yousign_document_id,
            document_yousign_requete_id: document.document_yousign_requete_id,
            document_yousign_statut: res.status,
          },
          document.document_id
        );*/
      });
  };

  const handleView = (record) => {
    const urlAfficher = `https://api.yousign.app/v3/signature_requests/${record?.document}/documents/download`;
    fetch(urlAfficher, {
      method: "GET",
      headers: {
        Authorization: "Bearer 8lj0pevKaOYCEpceDU3P4hBMhw2kl9fA",
      },
    });
  };

  return (
    <>
      <Spin
        size="fullScreen"
        tip="Chargement en cours..."
        spinning={loading}
        fullscreen={loading}
      />
        <div style={{padding: 10}}>

          <Row>
            <Space direction="vertical" size={0}>
              <Title style={{margin: 0, color: '#1E2A4A'}} level={2}>Récapitulatif des documents signés</Title>
              <Text style={{fontSize: 16, fontStyle: "italic", color: "#4A4A4A"}}>{`Nombre de document(s): ${filteredCount}`}</Text>
            </Space>
          </Row>

          <Row style={{textAlign: "right", marginBottom: 20}}>
            <Col span={24}>
              <Space wrap>
                <Select
                  value={selectedYear}
                  style={{textAlign: 'left', width: 120}}
                  onChange={handleYearChange}
                  options={years.map(year => ({value: year, label: year.toString()}))}
                />
                <DatePicker
                  allowClear={true}
                  locale={locale}
                  format="DD/MM/YYYY"
                  pickerValue={pickerValue}
                  onPickerValueChange={(val) => setPickerValue(val)}
                  value={startDate} // Liaison de l'état
                  onChange={(date) => {
                    setStartDate(date);
                    setEndDate(date);   // aligne la date de fin sur la date de début
                  }}
                  minDate={dayjs(`${selectedYear}-01-01`)}
                  maxDate={dayjs(`${selectedYear}-12-31`)}
                />
                <DatePicker
                  allowClear={true}
                  locale={locale}
                  format="DD/MM/YYYY"
                  pickerValue={pickerValue}
                  onPickerValueChange={(val) => setPickerValue(val)}
                  value={endDate} // Liaison de l'état
                  onChange={(date) => setEndDate(date)} // Mise à jour de l'état
                  minDate={dayjs(`${selectedYear}-01-01`)}
                  maxDate={dayjs(`${selectedYear}-12-31`)}
                />
              </Space>
            </Col>
          </Row>

        </div>

        <div style={{margin: "0 10px"}} ref={containerRef}>
          <Table
            className="list-data"
            // dataSource={documents}
            dataSource={filteredDocuments}
            columns={youSignColumns(handleRefresh, handleView)}
            pagination={false}
            scroll={{y: tableHeight}}
            rowKey="id"
          />
        </div>

    </>
  );
};

export default Yousign;